/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} Video_Export_File_Exists_TextInputs */

const en_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A file named "${i?.fileName}" already exists in the selected folder. Do you want to overwrite it?`)
};

const fr_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un fichier nomme "${i?.fileName}" existe deja dans le dossier selectionne. Voulez-vous l'ecraser ?`)
};

const de_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine Datei mit dem Namen "${i?.fileName}" existiert bereits im ausgewählten Ordner. Möchten Sie sie überschreiben?`)
};

const it_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un file denominato "${i?.fileName}" esiste gia nella cartella selezionata. Vuoi sovrascriverlo?`)
};

const ru_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Файл с именем "${i?.fileName}" уже существует в выбранной папке. Хотите перезаписать его?`)
};

const es_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ya existe un archivo llamado "${i?.fileName}" en la carpeta seleccionada. ¿Desea sobrescribirlo?`)
};

const zh_cn2_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`所选文件夹中已存在名为 "${i?.fileName}" 的文件。是否要覆盖它？`)
};

const ja_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選択したフォルダに "${i?.fileName}" という名前のファイルが既に存在します。上書きしますか？`)
};

const hi_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चयनित फ़ोल्डर में "${i?.fileName}" नाम की एक फ़ाइल पहले से मौजूद है। क्या आप इसे ओवरराइट करना चाहते हैं?`)
};

const pt_pt2_video_export_file_exists_text = /** @type {(inputs: Video_Export_File_Exists_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ja existe um ficheiro com o nome "${i?.fileName}" na pasta selecionada. Pretende substitui-lo?`)
};

/**
* | output |
* | --- |
* | "A file named \"{fileName}\" already exists in the selected folder. Do you want to overwrite it?" |
*
* @param {Video_Export_File_Exists_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_file_exists_text = /** @type {((inputs: Video_Export_File_Exists_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_File_Exists_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_file_exists_text(inputs)
	if (locale === "de") return de_video_export_file_exists_text(inputs)
	if (locale === "it") return it_video_export_file_exists_text(inputs)
	if (locale === "ru") return ru_video_export_file_exists_text(inputs)
	if (locale === "es") return es_video_export_file_exists_text(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_file_exists_text(inputs)
	if (locale === "ja") return ja_video_export_file_exists_text(inputs)
	if (locale === "hi") return hi_video_export_file_exists_text(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_file_exists_text(inputs)
	return en_video_export_file_exists_text(inputs)
});